import featureFlags from 'modules/featureFlags/featureFlags';

export * from 'modules/featureFlags/constants';
export default featureFlags;
